<template>
	<div class="bar">
		<div class="bar_left">
			<div class="b_poh">
				<div class="poh_text">
					<div class="pohbox" v-for="(item,index) in opt" :key="index" @click="optfun(index)">
						<span v-if="lang==0">{{item.cn}}</span>
						<span v-if="lang==1">{{item.en}}</span>
						<span v-if="lang==2">{{item.jp}}</span>
						<span v-if="lang==3">{{item.kr}}</span>
					</div>
					<div class="pohbox" @click="nuv()">
						<span v-if="lang==0">全国旅游监管服务平台</span>
						<span v-if="lang==1">Tourism regulation</span>
						<span v-if="lang==2">全国観光規制</span>
						<span v-if="lang==3">관광 감독</span>：12345
					</div>
				</div>
				
				<!-- <div class="poh_text">
					<div class="pohbox">
						<span v-if="lang==0">景区地址：湖北省十堰市郧西县观音镇天河口村</span>
						<span v-if="lang==1">Address: G318 (Hu Nie Line), Qushui County, Lhasa, Xizang Autonomous Region</span>
						<span v-if="lang==2">観光地住所：チベット自治区ラサ市曲水県G 318（上海聶線）</span>
						<span v-if="lang==3">관광지 주소: 서장자치구 라싸시 곡수현 G318 (상해섭선)</span>
					</div>
				</div> -->
			</div>
		</div>
		
		<div class="bar_right">
			<div class="right_text">
				<div class="optbox">
					<div class="opt_text">
						<span v-if="lang==0"> 咨询电话：</span>
						<span v-if="lang==1"> telephone：</span>
						<span v-if="lang==2"> コンサルティング：</span>
						<span v-if="lang==3"> 컨설팅：</span>
						{{this.$store.state.advice}}
					</div>
					<div class="opt_text">
						<span v-if="lang==0">投诉电话：</span>
						<span v-if="lang==1">complaint：</span>
						<span v-if="lang==2">クレーム：</span>
						<span v-if="lang==3">고소：</span>
						{{this.$store.state.complaint}}
					</div>
					<div class="opt_text">
						<span v-if="lang==0">救援电话：</span>
						<span v-if="lang==1">Rescue phone number：</span>
						<span v-if="lang==2">救援電話：</span>
						<span v-if="lang==3">구조 전화：</span>
						{{this.$store.state.rescue}}
					</div>
				</div>
				<!-- <div class="belong">
					CopyRight © 2025 tianhekouluyouqu All Rights Reserved.Design
				</div> -->
				<div class="belong" style="padding-left:10px">
					<span @click="rescue()">
						技术支持：<span v-if="lang==0">至上互动 </span>
						<span v-if="lang==1">Supreme interaction</span>
						<span v-if="lang==2">至上互动</span>
						<span v-if="lang==3">최상의 상호 작용</span>
					</span>
					<span @click="ban()" > 鄂ICP备2025109155号-1</span>
				</div>
			</div>
		</div>
		
		<!-- <div class="max_box">
			<div class="max_name">
				<span v-if="lang==0">最大承载量</span>
				<span v-if="lang==1">maximum</span>
				<span v-if="lang==2">さいだいしじょうりょう</span>
				<span v-if="lang==3">최대 적재량</span>
				<br />
				<span v-if="lang==0">（个）</span>
				<span v-if="lang==1">(pieces)</span>
				<span v-if="lang==2">（個）</span>
				<span v-if="lang==3">(개)</span>
			</div>
			<div class="max_num">
				{{this.$store.state.max}}
			</div>
		</div> -->
		
		<!--  -->
		<div class="riesun" v-if="riesunfalg" @click="close()">
			<div class="riesun_box">
				<img class="riesun_img" src="../static/home/riesun.png" alt="">
			</div>
		</div>
		
	</div>
</template>
<!--  -->
<script>
	export default {
		data() {
			return {
				opt:[
					{
						cn:"关于我们",
						en:"",
						jp:"",
						kr:"",
					},
					{
						cn:"新闻中心",
						en:"",
						jp:"",
						kr:"",
					},
					{
						cn:"虚拟景区",
						en:"",
						jp:"",
						kr:"",
					},
					{
						cn:"联系我们",
						en:"",
						jp:"",
						kr:"",
					}
				],
				
				riesunfalg:false,
				
				lang: 0,
			}
		},
		created(){
			this.lang = JSON.parse(localStorage.getItem("langs")) || 0;
		},
		methods:{
			nuv(){		//服务平台
				window.open('https://jbts.mct.gov.cn/',"_blank");
			},
			ban(){		//备案
				window.open('https://beian.miit.gov.cn/#/Integrated/index',"_blank");
			},
			
			// 名片
			rescue(){
				this.riesunfalg = true
			},
			close(){
				this.riesunfalg = false
			},
			
			
			optfun(e){
				if(e==0){
					if(this.$route.name == 'wisdom'){
						this.$router.push({name:'refresh',query:{index:6}})
					}else{
						this.$router.push({name:'wisdom',query:{index:6}})
					}
				}
				if(e==1){
					if(this.$route.name == 'theme'){
						this.$router.push({name:'refresh',query:{index:2}})
					}else{
						this.$router.push({name:'theme',query:{index:2}})
					}
				}
				if(e==2){
					if(this.$route.name == 'play'){
						this.$router.push({name:'refresh',query:{index:3}})
					}else{
						this.$router.push({name:'play',query:{index:3}})
					}
				}
				if(e==3){
					if(this.$route.name == 'service'){
						this.$router.push({name:'refresh',query:{index:4}})
					}else{
						this.$router.push({name:'service',query:{index:4}})
					}
				}
				if(e==4){
					if(this.$route.name == 'contact'){
						this.$router.push({name:'refresh',query:{index:9}})
					}else{
						this.$router.push({name:'contact',query:{index:9}})
					}
				}
				if(e==5){
					if(this.$route.name == 'contact'){
						this.$router.push({name:'refresh',query:{index:9}})
					}else{
						this.$router.push({name:'contact',query:{index:9}})
					}
				}
				
			},
			
		},
		
	}
</script>

<style scoped lang="less">
	.bar{
		height: 30px;
		width: 1920px;
		z-index: 100;
		box-sizing: border-box;
		color: #fff;
		display: flex;
		justify-content: space-between;
		background-color: rgba(0, 0, 0, .5);
		position: absolute;
		padding: 0 25px;
		bottom: 0;
		left: 0;
		z-index: 100;
	}
	
	.bar_left{
		height: 30px;
		line-height: 30px;
		display: flex;
	}
	.b_poh{
		font-size: 14px;
		display: flex;
		justify-content: space-around;
	}
	.poh_text{
		display: flex;
	}
	.pohbox{
		padding: 0 10px;
		position: relative;
	}
	.poh_text .pohbox:nth-child(1)::after,.poh_text .pohbox:nth-child(2)::after,.poh_text .pohbox:nth-child(3)::after{
		content: '';
		height: 15px;
		width: 1px;
		background-color: #ffffff;
		position: absolute;
		right: 0;
		top:8px;
	}
	.bar_right{
		display: flex;
		height: 30px;
		line-height: 30px;
	}
	.right_text{
		margin-right: 10px;
		display: flex;
		align-items: flex-end;
		justify-content: space-around;
	}
	.optbox{
		display: flex;
	}
	.opt_text{
		padding: 0 8px;
		font-size: 14px;
	}
	.opt_text:last-child{
		padding: 0 0 0 8px;
		border-right: 0px solid #fff;
	}
	
	.er_box{
		display: flex;
		align-items: center;
		margin-right: 10px;
	}
	.er_box:last-child{
		margin-right: 0px;
	}
	.belong{
		font-size: 14px;
	}
	.riesun{
		position: fixed;
		z-index: 1000;
		top: 0;
		left: 0;
		width: 1920px;
		height: 100vh;
		background-color: rgba(0, 0, 0, .5);
	}
	.riesun_box{
		width: 1000px;
		position: absolute;
		top: 50%;
		left: 50%;
		transform:translate(-50%,-50%);
		background-color: #363636;
	}
	.riesun_img{
		width: 100%;
	}
</style>